/// <amd-module name="TFS/Admin/Views/ProfileSettings/AuthorizationsView/Components/ApplicationDataPanelView" />
import React = require("react");
import * as Resources from "TFS/Admin/Views/ProfileSettings/AuthorizationsView/Resources";

import { IApplicationDataPanelProps } from "TFS/Admin/Views/ProfileSettings/AuthorizationsView/Contracts/DataModel";
import { Link } from "VSSUI/Link";
import { Panel } from "VSSUI/Panel";

export class ApplicationDataPanelView extends React.Component<IApplicationDataPanelProps> {
    public render() {
        const { selectedRow, onDismiss } = this.props;
        const { organizationName, registrationName, organizationLocation }: any = selectedRow.clientRegistration;
        const description = this._concatAppDescriptions(selectedRow.scopeDescriptions);
        return (
            <Panel onDismiss={() => onDismiss()} titleProps={{ text: Resources.ApplicationTitlePanel }} footerButtonProps={this._getFooterButtons()}>
                <div>
                    <h4> {Resources.Name}</h4>
                    <div> {registrationName}</div>
                    <h4> {Resources.CompanyName}</h4>
                    <Link href={organizationLocation} target="_blank">
                        {organizationName}
                    </Link>
                    <h4> {Resources.Description}</h4>
                    <div> {description}</div>
                </div>
            </Panel>
        );
    }

    private _getFooterButtons() {
        return [
            {
                text: Resources.CloseBtn,
                primary: true,
                onClick: () => this.props.onDismiss()
            }
        ];
    }

    private _concatAppDescriptions(descriptions: any) {
        return descriptions
            .map((app: any) => {
                return app.description;
            })
            .join(". ");
    }
}
